// extracted by mini-css-extract-plugin
export default {"info":"Alert_info__8lu8w"};